/**
 * @file user.js
 * Exports constants pertaining to API paths.
 */

export const API_ENDPOINT_USER_LOGIN = 'oauth/token';
export const API_ENDPOINT_USER_REGISTER = 'user/register';
export const API_ENDPOINT_USER_PASSWORD = 'user/password';
export const API_ENDPOINT_XCSRF_TOKEN = 'rest/session/token';
export const API_ENDPOINT_EXPERIENCE = 'node/experience';
export const API_ENDPOINT_FILE_IMAGE = 'file/image';
export const API_ENDPOINT_FILE_VIDEO = 'file/video';
export const API_ENDPOINT_FILE_AUDIO = 'file/audio';
export const API_ENDPOINT_SCENE = 'node/scene';
export const API_ENDPOINT_COMPONENT = 'node/component';
export const API_TYPE_EXPERIENCE = 'node--experience';
export const API_TYPE_SCENE = 'node--scene';
export const API_TYPE_COMPONENT = 'node--component';
export const API_TYPE_FILE_IMAGE = 'file--image';
export const API_TYPE_FILE_VIDEO = 'file--video';
export const API_TYPE_FILE_AUDIO = 'file--audio';



// WEBPACK FOOTER //
// ./src/constants/api.js